
import TableList from "@components/templates/tablelist";
import { HttpGetBillNameList, HttpDeleteBillNameOne } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";
import compIndex from './update'
export default {
    mixins: [TableList],
    components:{
        compIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_expenseCategoryType:null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpGetBillNameList,
        
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'bigaccountbillnameDetail',
                        params: { type: 'add' },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'bigaccountbillnameDetail',
                        params: { type: "edit"},
                        query: { id: params , sourceType: this.formData.search.EQ_type },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "compIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "删除操作",
                        ajaxRequest:HttpDeleteBillNameOne
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: true,
                params:id,
                operate:'edit'
            },{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList','getCarrierAllList']),
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    key: 'EQ_carrier',
                    tag: 'vSelect',
                    options:this.getCarrierAllList,
                    props:{
                        filterable:true
                    },
                    show: true,
                },
                // {
                //     label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                //     tag: 'vSelect',
                //     key: 'EQ_service',
                //     more: true,
                //     options: this.getCarrierServiceList.map(item=>{
                //         return {
                //             value: item.value,
                //             label: item.label
                //         }
                //     }),
                //     props: {
                //         filterable: true,
                //     },
                //     show: true,
                // },
                {
                    label: '费用名称',
                    tag: 'vInput',
                    key: 'CN_costName',
                    show: true,
                },
                {
                    label: '费用分类',
                    tag: 'vInput',
                    key: 'CN_costCategory',
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                // {
                //     show:false,
                //     type: 'selection',
                //     width: 60,
                //     align: 'center',
                //     formName: 'id'
                // },
                {
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    key: 'carrier',
                    render: (h, { row }) => this.findRenderLabel(this.getCarrierAllList, row.carrier),
                },
                // {
                //     title: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                //     key: 'service',
                //     render: (h, { row }) => {
                //         return <div>{this.findRenderLabel(this.getCarrierServiceList, row.service) || '--'}</div>
                //     }
                // },
                {
                    title: '费用名称',
                    key:'costName'
                },
                {
                    title: '费用分类',
                    key:'costCategory'
                },
                {
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
